module.exports = __webpack_public_path__ + "media/fonts/fontawesome-webfont-2936772672cf45f34b310897010e78e5.svg";